import React, { CSSProperties, FC } from 'react';
import RouteLink from '../../../../../../ReactSharedScripts/components/RouteLink';

type SpreadsheetRowLinkProps = {
	href?: string;
	tagName?: keyof JSX.IntrinsicElements;
	forceUseLink?: boolean;
	disabled?: boolean;
	className?: string;
	style?: CSSProperties;
	onClick?: (e: React.MouseEvent<HTMLElement, React.MouseEvent>) => void;
};

const SpreadsheetRowLink: FC<React.PropsWithChildren<SpreadsheetRowLinkProps>> = ({
	href,
	tagName = 'li',
	disabled,
	children,
	className,
	style,
	onClick,
	forceUseLink,
}) => {
	return (
		<RouteLink
			// @ts-ignore
			tagName={tagName}
			onClick={onClick}
			className={className}
			style={style}
			href={href}
			preventDefault={false}
			disabled={disabled}
			forceUseLink={forceUseLink}
			hasColor={false}
		>
			{children}
		</RouteLink>
	);
};

export default SpreadsheetRowLink;
